import { environment } from "../constance";
import bscMainnetAddresses from "./bsc-mainnet";
import bscTestnetAddresses from "./bsc-testnet";

export function getCurrentContractAddresses() {
  return environment === "testnet" ? bscTestnetAddresses : bscMainnetAddresses;
}
